// extracted by mini-css-extract-plugin
export default {"modal-footer":"modal_modal-footer__YR4sW","modal-wrapper":"modal_modal-wrapper__pk46w","modal-title":"modal_modal-title__9cbN8","close-btn-wrapper":"modal_close-btn-wrapper__wLK6m"};